export default __webpack_public_path__ + "static/media/AssignmentsMenuIcon.034e20b3.svg";